/* eslint-disable no-nested-ternary */
import React from 'react';

const Block = ({role, permission, selected, id, onUpdatePermission}) => {
  if (id < 10) id = `0${id}`;
  const action = permission ? permission.action : '';
  const contentType = permission ? permission.type : '';
  const ActionFirstChar = action.toString().charAt(0).toUpperCase();
  role.permissions.find((p) => p.action === action && p.type === contentType);
  if (!permission || permission.no === 0) {
    return (
      <>
        <div className="d-inline-block block border-none"></div>
      </>
    );
  }
  return (
    <>
      <button
        className={`d-inline-block block btn-div pl-2 ${
          selected ? 'bg-gray3' : 'bg-white'
        }`}
        onClick={(e) => {
          e.preventDefault();
          onUpdatePermission();
        }}
      >
        <h6 className={`${selected ? 'text-white' : 'text-gray-3'}`}>
          {ActionFirstChar}
          {contentType.toString().charAt(0).toLowerCase()} <sup>{id}</sup>
        </h6>
        <div
          className={`text-capitalize role-detail ${
            selected ? 'text-white' : 'text-gray-3'
          }`}
        >
          {action} {contentType}
        </div>
      </button>
    </>
  );
};
export default Block;
